<div class="custom-snackbar" matSnackBarLabel>
	<mat-icon>warning</mat-icon>
	<span class="snackbar-message">{{ message }}</span>
	<span matSnackBarAction>
	  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
	</span>
</div>

